import { IModal } from '@app/interfaces/modal';
import { IObservable, ISubject, Subject } from '@app/utils/observable';
import { Template } from '@app/utils/template';
import { ICheckboxChangeArgs } from '@app/interfaces/checkbox';
import { AllowanceTypeAccordionItemComponent, AllowanceTypeAccordionItemExpenditureTypeChangeArgs } from './accordion-item';
import { toDictionary } from '@app/utils/to-dictionary';

import "jquery-ui";
import 'jquery-ui/ui/widgets/accordion';

export class AllowanceTypePickerModalComponent implements IModal {
    private readonly closeEventSubject: ISubject<IModal, any>;
    private readonly allowanceTypeChangeSubject: ISubject<AllowanceTypePickerModalComponent, ICheckboxChangeArgs<number>>;
    private readonly expenditureTypeChangeSubject: ISubject<AllowanceTypePickerModalComponent, AllowanceTypeAccordionItemExpenditureTypeChangeArgs>;

    private element?: HTMLElement;
    private modalContent?: HTMLElement;

    public allowanceTypeMap: { [key: number]: AllowanceTypeAccordionItemComponent; } = {};
    public allowanceTypeIds: number[] = []; // Array of IDs kept alongside map to preserve ordering
    public clearing: boolean = false;
    public get allowanceTypes(): AllowanceTypeAccordionItemComponent[] {
        return this.allowanceTypeIds.map(id => this.allowanceTypeMap[id]);
    }

    get onClose$(): IObservable<IModal, any> {
        return this.closeEventSubject;
    }

    get onExpenditureTypeChange$(): IObservable<AllowanceTypePickerModalComponent, AllowanceTypeAccordionItemExpenditureTypeChangeArgs> {
        return this.expenditureTypeChangeSubject;
    }

    constructor(allowanceTypes: AllowanceTypeAccordionItemComponent[]) {
        this.closeEventSubject = new Subject;
        this.allowanceTypeChangeSubject = new Subject;
        this.expenditureTypeChangeSubject = new Subject;

        // function binding
        this.onExpenditureTypeChange = this.onExpenditureTypeChange.bind(this);

        this.allowanceTypeIds = allowanceTypes.map(c => c.id);
        this.allowanceTypeMap = toDictionary(allowanceTypes, c => c.id);

        for (const allowanceType of allowanceTypes) {
            allowanceType.onExpenditureTypeChange$.subscribe(this.onExpenditureTypeChange);
        }
    }

    onExpenditureTypeChange(sender: AllowanceTypeAccordionItemComponent, args: AllowanceTypeAccordionItemExpenditureTypeChangeArgs) {
        this.expenditureTypeChangeSubject.emit(this, args);
    }

    shouldCloseModal() {
        return true;
    }

    render(): HTMLElement[] {
        if (this.element) {
            return [this.element];
        }

        const html = Template.getById("allowance-type-picker-modal");
        const content = html.querySelector(".modal__content")! as HTMLElement;

        for (const allowanceType of this.allowanceTypes) {
            const elements = allowanceType.render();
            $(allowanceType.header).addClass("modal__content--padded-width");
            $(".allowance-type-accordion__expenditure-type", allowanceType.content).addClass("modal__content--padded-width");
            $(".allowance-type-accordion__toggle-all", allowanceType.content).addClass("modal__content--padded-width");
            $(content).append(elements);
        }

        $(content).accordion({
            animate: 200,
            collapsible: true,
            heightStyle: "content",
            active: false
        });

        this.attachButtonEventListeners(html);

        this.modalContent = content;
        this.element = html;
        
        return [html];
    }

    reset() {
        this.clearing = true;
        for (const allowanceType of this.allowanceTypes) {

            for (const expenditureType of allowanceType.expenditureTypes) {
                expenditureType.checked = false;
            }
        }
        this.clearing = false;
    }

    attachButtonEventListeners(element: HTMLElement) {
        const clearButton = element.querySelector(".allowance-type-picker-modal__clear-button") as HTMLElement;
        const okButton = element.querySelector(".allowance-type-picker-modal__ok-button") as HTMLElement;

        clearButton.addEventListener("click", ev => {
            this.reset();
        });

        okButton.addEventListener("click", ev => {
            this.closeEventSubject.emit(this, null);
        });
    }
}